export const WorkplaceMenu = [
  {
    title: '대시보드',
    path: '/dashboard',
    icon: 'UXicon-navi_home',
    accountsTypes: ['OWNER', 'BRAND_MANAGER', 'MEMBER']
  },
  {
    title: '상담 분석',
    icon: 'UXicon-navi_report',
    path: '/ticket/dashboard',
    accountsTypes: ['OWNER', 'BRAND_MANAGER'],
    children: [
      {
        title: '티켓 분석',
        children: [
          {
            title: '티켓 대시보드',
            path: '/ticket/dashboard',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '티켓 통계',
            path: '/ticket/statistics',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ],
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '상담 분석',
        children: [
          {
            title: '상담 현황',
            path: '/report/consult_status',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '상담 통계',
            path: '/report/consult_statistics',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '상담 내역',
            path: '/report/consult_history',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '상담사 지연 현황',
            path: '/report/delay_status',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ],
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '메시지 분석',
        children: [
          {
            title: '메시지 발송 통계',
            path: '/message/send_statistics',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ],
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '콜 상담 분석',
        children: [
          {
            title: '상담 현황',
            path: '/report/call_status',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '상담 통계',
            path: '/report/call_statistics',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '상담 이력',
            path: '/report/call_history',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '상담콜 이력 현황',
            path: '/report/call_history_status',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '서비스 레벨 통계',
            path: '/report/call_service_level',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '상담사 상태 통계',
            path: '/report/call_agent_statistics',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ],
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '성과 분석',
        children: [
          {
            title: '상담 평가 지표',
            path: '/report/consult_evaluate',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '상담 품질 지표',
            path: '/report/consult_quality',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ],
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '설문조사 분석',
        children: [
          {
            title: '설문조사 통계',
            path: '/report/survey_report',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ],
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '리포트 분석',
        children: [
          {
            title: '데이터 리포트',
            path: '/report/coun_report',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '상담 이슈 관리',
            path: '/report/issue_report',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ],
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      }
    ]
  },
  {
    title: '계정 관리',
    icon: 'UXicon-add_person',
    path: '/management/member',
    accountsTypes: ['OWNER', 'BRAND_MANAGER'],
    children: [
      {
        title: '계정 관리',
        children: [
          {
            title: '계정 관리',
            path: '/management/member',
            pages: [
              {
                title: '계정 수정',
                path: '/management/member/modify',
                accountsTypes: ['OWNER', 'BRAND_MANAGER']
              }
            ],
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '역할 관리',
            path: '/management/role',
            pages: [
              {
                title: '역할 수정',
                path: '/management/role/modify',
                accountsTypes: ['OWNER']
              },
              {
                title: '역할 추가',
                path: '/management/role/new',
                accountsTypes: ['OWNER']
              }
            ],
            accountsTypes: ['OWNER']
          },
          {
            title: '상담사 근태 관리',
            path: '/report/agents_status',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ],
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      }
    ]
  },
  {
    title: '콜 설정',
    icon: 'UXicon-navi_call',
    path: '/agent/call_consultant_setting',
    accountsTypes: ['OWNER', 'BRAND_MANAGER'],
    children: [
      {
        title: '콜 설정',
        children: [
          {
            title: '콜 내선 번호 관리',
            path: '/agent/call_consultant_setting',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '콜 자동 배정 설정',
            path: '/agent/call_deflect_setting',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ],
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      }
    ]
  },
  {
    title: '보안 관리',
    icon: 'UXicon-lock',
    path: '/brand/security',
    accountsTypes: ['OWNER'],
    children: [
      {
        title: '보안 관리',
        children: [
          {
            title: '보안 관리',
            path: '/brand/security',
            accountsTypes: ['OWNER']
          }
        ],
        accountsTypes: ['OWNER']
      }
    ]
  }
];
export const Workplace = WorkplaceMenu.map((d) => {
  d.pages = [];
  if (d.children) {
    d.children.map((o, subIdx) => {
      if (o.children) {
        o.pages = [];
      }
      if (o.children) {
        o.children.map((sub) => {
          if (sub.path) {
            const page = sub.pages ? sub.pages.map((p) => p.path) : [];
            page.push(sub.path);
            d.pages.push(...page);
            d.children[subIdx].pages.push(...page);
          }
        });
      }
    });
  } else {
    d.pages.push(d.path);
  }
  return d;
});

export const BrandMenu = [
  {
    title: '브랜드 관리',
    children: [
      {
        title: '기본 설정',
        path: '/brand/brand_management',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '상담 공지',
        path: '/notice/list',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: '상담 공지 수정',
            path: '/notice/modify',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '상담 공지 등록',
            path: '/notice/write',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      }
    ]
  },
  {
    title: '상품/구입처 관리',
    children: [
      {
        title: '상품',
        path: '/product_and_supplier_management/product',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '구입처',
        path: '/product_and_supplier_management/supplier',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      }
    ]
  },
  {
    title: '상품 관리',
    children: [
      {
        title: '상품',
        path: '/product_and_supplier_management/product',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      }
    ]
  },
  {
    title: '연동 관리',
    children: [
      {
        title: '채널 연동',
        path: '/brand/channel_systemlink',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: '웹챗/챗봇',
            path: '/brand/channel/webchat',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '카카오톡 상담톡',
            path: '/brand/channel/kakaotalk',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '네이버톡톡',
            path: '/brand/channel/navertalk',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '페이스북 메신저',
            path: '/brand/channel/facebook',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '메일',
            path: '/brand/channel/email',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: 'SMS',
            path: '/brand/channel/sms',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '카카오 알림톡',
            path: '/brand/channel/kakao_instant',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '콜',
            path: '/brand/channel/call',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: 'DataInsight',
            path: '/brand/channel/data_insight',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      },
      {
        title: '쇼핑몰 연동',
        path: '/brand/commerce_management',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: '스마트 스토어',
            path: '/brand/commerce/smartstore',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '메이크샵',
            path: '/brand/commerce/makeshop',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '카페24',
            path: '/brand/commerce/cafe24',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '자사몰',
            path: '/brand/commerce/companymall',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      }
    ]
  },
  {
    title: '상담 관리',
    children: [
      {
        title: '상담 배분',
        path: '/brand/brand_counsel_distribution_management',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '상담 유형',
        path: '/agent/consulting_type',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: '상담 유형 등록',
            path: '/agent/consulting_type/registration',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '상담 유형 수정',
            path: '/agent/consulting_type/update',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      },
      {
        title: '상담 템플릿',
        path: '/agent/consulting_template',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: '타이틀',
            path: '/agent/consulting_template/registration',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '타이틀',
            path: '/agent/consulting_template/update',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      }
    ]
  },
  {
    title: '채팅 상담 관리',
    children: [
      {
        title: '상담 버튼 설치',
        path: '/channel/channel_button',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: '카카오톡 오픈',
            path: '/kakao/chat/open',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      },
      {
        title: '자동 메시지',
        path: '/brand/brand_auto_message',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '상담 분류',
        path: '/agent/category_management',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '챗봇 시나리오',
        path: '/chatbot/chatbot_intro',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: '타이틀',
            path: '/chatbot/chatbot_edit',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '타이틀',
            path: '/chatbot/preview',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      },
      {
        title: '금칙어 추가/삭제',
        path: '/brand/brand_ban_word_management',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      }
    ]
  },
  {
    title: '1:1 문의 상담 관리',
    children: [
      {
        title: '추천 답변',
        path: '/inquiry/recommended_answer',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '상담 인사말',
        path: '/inquiry/counsel_greeting',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      }
    ]
  },
  {
    title: 'AI 상담 서비스 관리',
    children: [
      {
        title: 'AI FAQ 어시스턴트',
        path: '/brand/aiCounselAssistance',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: 'AI FAQ 어시스턴트 수정',
            path: '/brand/aiCounselAssistance/edit',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      },
      {
        title: 'AI 챗봇 설정',
        path: '/brand/ai_chatbot_setting',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      }
    ]
  },
  {
    title: '콜 상담 관리',
    icon: '',
    children: [
      {
        title: '예약 상담',
        path: '/agent/reservation_management',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: '타이틀',
            path: '/agent/reservation_registration',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '타이틀',
            path: '/agent/reservation/ticket',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      },
      {
        title: '고객 클레임 정보',
        path: '/client/claim_information_management',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: '타이틀',
            path: '/client/claim_information/create',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '타이틀',
            path: '/client/claim_information/update',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      },
      {
        title: '문의유형 설정',
        path: '/inqury_type_setting',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: '타이틀',
            path: '/inqury_type_setting',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      }
    ]
  },
  {
    title: '설문조사 관리',
    icon: '',
    children: [
      {
        title: '설문조사 설정',
        path: '/survey_setting',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '설문조사 진행상태',
        path: '/survey_status',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: '타이틀',
            path: '/survey_management',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          },
          {
            title: '미리보기',
            path: '/survey/preview',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      }
    ]
  }
];

export const Brand = BrandMenu.map((d) => {
  d.pages = [];
  if (d.children) {
    d.children.map((o, subIdx) => {
      if (o.children) {
        o.pages = [];
      }
      if (o.children) {
        o.children.map((sub) => {
          if (sub.path) {
            const page = sub.pages ? sub.pages.map((p) => p.path) : [];
            page.push(sub.path);
            d.pages.push(...page);
            d.children[subIdx].pages.push(...page);
          }
        });
      }
    });
  } else {
    d.pages.push(d.path);
  }
  return d;
});

export const ConsultDesk = {
  OPERATION_MENU: {
    title: '채팅 상담 데스크',
    path: '/operation',
    icon: 'UXicon-navi_talk'
  },
  CONTACT_SUPPORT_MENU: {
    title: '1:1 문의 내역',
    path: '/contact_support_desk',
    icon: 'UXicon-navi_board'
  },
  INQUIRY_DESK_MENU: {
    title: '문의 게시판',
    path: '/inquiry_desk',
    icon: 'UXicon-navi_qna'
  },
  CALL_OPERATION_MENU: {
    title: '콜 상담 데스크',
    path: '/call/operation',
    icon: 'UXicon-navi_call'
  },
  TICKET_MENU: {
    title: '티켓',
    icon: 'UXicon-navi_ticket',
    path: '/ticket/my_ticket',
    children: [
      {
        title: '티켓',
        parentNode: 'TICKET_MENU',
        path: '/ticket/my_ticket',
        children: [
          {
            title: '나에게 할당된 티켓',
            path: '/ticket/my_ticket',
            pages: [
              {
                title: '티켓 등록',
                path: '/ticket/ticket_create'
              },
              {
                title: '티켓 상세',
                path: '/ticket/ticket_details'
              }
            ]
          },
          {
            title: '전체 티켓',
            path: '/ticket/list',
            pages: [
              {
                title: '티켓 등록',
                path: '/ticket/list/ticket_create'
              },
              {
                title: '티켓 상세',
                path: '/ticket/list/ticket_details'
              },
              {
                title: '티켓 팝업 상세',
                path: '/operation/ticket'
              }
            ]
          },
          {
            title: '발주티켓',
            path: '/ticket/order_ticket',
            pages: [
              {
                title: '발주티켓 상세',
                path: '/ticket/order_ticket_details'
              },
              {
                title: '발주티켓 팝업 상세',
                path: '/operation/order_ticket'
              }
            ]
          }
        ]
      },
      {
        title: 'VOC 티켓',
        parentNode: 'TICKET_MENU',
        path: '/voc_ticket/my_ticket',
        children: [
          {
            title: '나의 VOC 티켓',
            path: '/voc_ticket/my_ticket',
            pages: [
              {
                title: 'VOC 티켓 등록',
                path: '/voc_ticket/ticket_create'
              },
              {
                title: 'VOC 티켓 상세',
                path: '/voc_ticket/ticket_details'
              },
              {
                title: 'VOC 티켓 팝업 상세',
                path: '/operation/voc_ticket'
              }
            ]
          },
          {
            title: '전체 VOC 티켓',
            path: '/voc_ticket/list',
            pages: [
              {
                title: 'VOC 티켓 등록',
                path: '/voc_ticket/list/ticket_create'
              },
              {
                title: 'VOC 티켓 상세',
                path: '/voc_ticket/list/ticket_details'
              }
            ]
          }
        ]
      }
    ]
  },
  MESSAGE_MENU: {
    title: '메시지',
    icon: 'UXicon-navi_send',
    path: '/message/send_message',
    children: [
      {
        title: '메시지',
        parentNode: 'MESSAGE_MENU',
        path: '/message/send_message',
        children: [
          {
            title: '메시지 발송',
            path: '/message/send_message'
          },
          {
            title: '메시지 템플릿',
            path: '/message/message_template_management'
          },
          {
            title: '메시지 발송 내역',
            path: '/message/send_history'
          }
        ]
      },
      {
        title: '메일',
        parentNode: 'MESSAGE_MENU',
        path: '/message/mail_send_history',
        children: [
          {
            title: '메일 발송 내역',
            path: '/message/mail_send_history',
            pages: [
              {
                title: '메일 발송',
                path: '/message/mail_send'
              }
            ]
          }
        ]
      }
    ]
  },
  CUSTOM_MENU: {
    title: '1:1 문의게시판',
    icon: 'UXicon-consultation',
    path: '/consultation'
  }
};

export const OrderTicketMenu = {
  title: '발주티켓',
  path: '/ticket/order_ticket',
  pages: [
    {
      title: '발주티켓 상세',
      path: '/ticket/order_ticket_details'
    },
    {
      title: '발주티켓 팝업 상세',
      path: '/operation/order_ticket'
    }
  ]
};

export const Icomsys = [
  {
    title: '영상상담',
    icon: 'UXicon-navi_videocall',
    path: '/icomsys/video_counseling'
  },
  {
    title: '상담이력 조회"',
    icon: 'UXicon-navi_history',
    path: '/icomsys/fetch_counseling_list'
  },
  {
    title: '카테고리 관리',
    icon: 'UXicon-navi_category',
    path: '/icomsys/category_management'
  },
  {
    title: '영상상담 통계',
    icon: 'UXicon-navi_report',
    path: '/icomsys/counseling_statistics'
  }
];



// WEBPACK FOOTER //
// ./src/constants/sidebarMenu.js